import { ANALYTICS_CHANNEL, useJqlPackageAnalytics } from '@atlaskit/jql-editor-common';
export var useJqlEditorAutocompleteAnalytics = function useJqlEditorAutocompleteAnalytics(analyticsSource) {
  return useJqlPackageAnalytics(analyticsSource, "@atlaskit/jql-editor-autocomplete-rest", "2.1.1", ANALYTICS_CHANNEL);
};
export { ActionSubjectId, ActionSubject, Action } from './types';